<template>
  <div class="box">
    <div class="tabNew" v-if="tabBar && !isApp" :class="navBarFixed ? 'navBarFixed' : ''">
      <div class="tabTop">
        <div>
          <ul>
            <img class="hongshi" src="../../../../static/common/wap/hongshi.png" alt="">
            <p>
              <span style="font-weight:600;font-size:13px;">红狮启富</span>
              <span>应用版本：5.0.0</span>
              <span>更新时间：2024年09月02日</span>
            </p>
          </ul>
          <img @click="downLoadApp" class="downLoadApp" src="../../../../static/common/wap/downloadApp.png" alt="">
        </div>
      </div>
      <p class="tabBottom">
        <span>应用权限:查看权限 隐私权限: 查看权限</span>
        <span>APP开发者: 红狮金业有限公司 应用名称:红狮启富</span>
      </p>
      <img @click="() => { tabBar = false; }" class="closer" src="../../../../static/common/wap/closer.png" alt="">
    </div>
    <div class="BannerBox">
      <img class="banner" src="/subject/newYear9911/wap/banner.png" alt=""> 
    </div>
    <div class="content">
      <div class="logins">
        <div id="login">
          <div class="interactive">
            <div class="line"></div>
            <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号">
            <div class="codeBox">
              <input v-model="form.code" type="text" placeholder="请输入验证码">
              <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
              <span v-else>重新获取({{ verSecond }})</span>
            </div>
            <img class="loginBtn" @click="submit(form)" src="/subject/newYear9911/wap/ljlq.png" alt="">
            <div class="djs">
              <div class="djs-box">
                倒计时
                <span class="logdjs-span">{{ days }}</span>天
                <span class="logdjs-span">{{ hours }}</span>时
                <span class="logdjs-span">{{ minutes }}</span>分
                <span class="logdjs-span">{{ seconds }}</span>秒
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="part">
        <div class="part-con">
          <div class="line"></div>
          <div class="img1"></div>
          <span class="part-1-span" @click="showDialog = true">活动详情</span>
          <div class="list">
            <div class="gift1" @click="focusInput()"></div>
            <div class="gift2">
              <div class="g100" @click="focusInput()"></div>
              <div class="g500" @click="focusInput()"></div>
            </div>
            <div class="gift-t"></div>
            <div class="part-1-bth">
              <div class="zxkf" @click="live800"></div>
              <div class="lzj" @click="focusInput()"></div>  
            </div>
          </div>
        </div>
      </div>
      <div class="part2">
        <div class="part-2-bth">
          <div class="line152"></div>
          <div class="p2con"></div>
          <div class="anniu">
            <div class="zxkf" @click="live800"></div>
            <div class="lzj" @click="focusInput()"></div>
          </div>
        </div>
      </div>
      <div class="part3">
        <div class="part-3-bth">
          <div class="line205"></div>
          <div class="list">
            <div class="con1"></div>
            <div class="con2"></div>
            <div class="con3"></div>
            <div class="con4"></div>
            <div class="con5"></div>
          </div>
          <div class="anniu">
            <div class="zxkf" @click="live800"></div>
            <div class="lzj" @click="focusInput()"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDialog" class="dialog">
      <img class="closer" @click="showDialog = false" src="/subject/mayPage/closer.png" alt="">
      <ul class="dialogContent">
        <h3>活动规则</h3>
        <li>
          <span>活动对象：</span>
          活动期间，在本平台开立真实账户，并首次入金的客户
        </li>
        <li>
          <span>活动时间：</span>
          即日起至{{ this.getLastDay() }}
        </li>
        <li style="color:#ad0000;">
          <span>活动规则：</span><br>
          活动期间，新用户可享双重福利：<br>
          1. 开户赠送$500现金券一张，盈利即送3美金；<br>
          2. 首次入金，充多少送多少，交易可返现，<span style="color:#ad0000;font-weight: 500;">上不封顶</span>；
        </li>
        <li>
          <span>开户领现金券活动：</span><br>
          1. 活动期间，开立真实账户赠送500美元现金券一张；<br>
          2. 现金券领取后可直接交易，使用有效期从当日00:00起计算，共计3天；<br>
          3. 每张现金券仅可交易1笔，现金券持仓单需在最近一次04:00前平仓，或由系统自动平仓；<br>
          4. 现金券交易后盈利即送3美金，直接发放到MT账户，用户可直接提现；<br>
          5. 盈利有效期为平仓后30天内，逾期扣回；<br>
          6. 现金券仅限伦敦金/伦敦银交易品种；<br>
        </li>
        <li>
          <span>首入金活动规则：</span><br>
          首次充值，充多少送多少美元赠金，奖励上不封顶；<br>
          72小时内总入金≥500美元，可额外获得100美元现金；<br>
          首入金奖励如下：<br>
        </li>
        <li class="imgLiBox">
          <img src="/subject/mayPage/wap/table.png" alt="">
        </li>
        <li>
          <span>美元赠金：</span><br>
          1、活动期间内，首次入金可获得等额的美元赠金（即赠金点）回馈；<br>
          2、 首入金有效期为第一笔入金后的72h内，赠送金额将按照72h后最终数额计算；<br>
          3、用户每交易一手伦敦金/伦敦银，返还相对应的赠金金额；该笔资金可交易可提现，用户可登录App-我的-赠金奖励中查看（未满一手按照实际交易手数占一手的比例计算）<br>
          4、美元赠金按交易手数返还，当月交易越多，每手返还越高！<br>
          <span style="color:#000000">
            更多活动详情，请下载App-我的-赠金奖励中查看，或咨询客服。
          </span>
        </li>
        <li>
          <span>美元现金：</span><br>
          1、美元现金直接入账，可交易，可提现；<br>
          2、用户在30天内完成≥10手交易即可提现，品种限伦敦金/伦敦银；<br>
          3、30天内未完成手数要求，活动到期时，系统仅扣回美元现金金额。<br>
          举例说明：A女士，入金520美元，获得100美元现金，账户实际到账金额为520+100=620美元，第15天，A女士完成10手交易，顺利提取100美元现金。
        </li>
        <li>
          <span>注意事项：</span><br>
          1. 客户参与活动需在本公司开立真实交易账户,参与该活动的新用户，为保证资金安全，在初始L1层级，账户强平比例上调至50%，升级后自动恢复为30%；<br>
          2. 交易手数计算：开仓一手平仓一手，如此来回算一手；<br>
          3. 本活动本公司新客户仅有一次机会参与，不可重复领取；<br>
          4. 凡推广商及其名下客户不参与本活动；<br>
          5. 本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
        </li>
      </ul>
    </div>
    <div class="dark" v-if="showDialog" @click="() => { showDialog = false }"></div>
    <div class="bottomBar" v-if="tabBar && !isApp" :class="BarIsBottom ? 'BarIsBottom' : ''">
      <p>
        <img src="../../../../static/common/wap/call.png" alt="">
        <span @click="live800">咨询客服</span>
      </p>
      <p>
        <img src="../../../../static/common/wap/dollars.png" alt="">
        <span @click="goLogin">立领$10000+$500新课礼包</span>
      </p>
    </div>
  </div>
</template>
<script>
import ContactusVue from "@/component/base-footer";
import userSign from '@/mixins/userSign';
import { mapState  } from "vuex";
export default {
  name: 'mayPageWap',
  components: {
    ContactusVue,
  },
  mixins: [ userSign ],
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      navBarFixed: false,
      scroll: '',
      screenWidth: null,
      isApp: false,
      showDialog: false,
      tabBar: true,
      BarIsBottom: false,
    }
  },
  created() {
    this.updateCountdown();
    setInterval(this.updateCountdown, 1000);
    this.$emit("controlShow", true);
    if (this.$route.query.isApp) {
      this.isApp = true;
    }
    window.addEventListener('scroll', this.scrollBottom);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    window.addEventListener('DOMContentLoaded', this.setRemUnit(), false);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollBottom) //页面离开后销毁监听事件
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    screenWidth: function (n) {
      if (n > 750) {
        this.$router.push({
          name: "newYear9911",
        });
      }
    },
  },
  computed: {
    ...mapState('common', {
      androidDownloadUrl: 'androidDownloadUrl',
      iosMt4DownloadUrl: 'iosMt4DownloadUrl',
    })
  },
  methods: {
    // 设置根字体大小自适应使用
    setRemUnit() {
      var docEl = document.documentElement;
      var baseSize = 750; // 设计稿宽度
      var targetBaseFontSize = 10; // 1rem对应的目标像素值
      function resizeHandler() {
        var clientWidth = docEl.clientWidth || window.innerWidth;
        docEl.style.fontSize = (clientWidth / baseSize) * targetBaseFontSize + 'px';
      }
      // 初始设置
      resizeHandler();
      // 添加窗口resize事件监听器
      window.addEventListener('resize', resizeHandler, false);
    },
    // 点击获取焦点
    focusInput() {
      this.$refs.inputElement.focus();
    },
    // 倒计时
    updateCountdown() {
      const today = new Date();
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const timeLeft = endOfMonth - today;

      this.days = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(2, '0');
      this.hours = String(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
      this.minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      this.seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

    },
    // 返回上级页面
    goback() {
      window.location.href = window.location.origin;
    },
    // 控制顶部的定位
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    // 提交手机号验证码
    submit(form) {
      if(form.phone && form.code){
        this.handleRegister().then(() => {
          setTimeout(() => {
            this.toUserCenter();
          }, 500)
        }).catch(() => {
        })
      }else{
        this.$message({
          message: '请输入手机号和验证码！',
          type: 'warning',
        });
      }
    },
    // 点击下载app
    downLoadApp() {
      var u = navigator.userAgent;
      if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
        try {
          window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
        } catch (error) {
          window.open(this.iosMt4DownloadUrl);
        }
      } else { // 安卓
        try {
          window.android.gotoRegisterReal();
        } catch (error) {
          window.open(this.androidDownloadUrl);
        }
      }
    },
    // 登录
    goLogin() {
      window.open('https://www.rlcproltd.net/uc/login');
    },
    // 判断是否滑到底部
    scrollBottom() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        // this.BarIsBottom = true;
      }
    },
    // 回到顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    //获取当月最后一天的日期
    getLastDay() {
      var year = new Date().getFullYear(); //获取年份
      var month = new Date().getMonth() + 1; //获取月份
      var lastDate = new Date(year, month, 0).getDate(); //获取当月最后一日
      month = month < 10 ? '0' + month : month; //月份补 0
      return year + '年' + month + '月' + lastDate + '日 23:59:59';
    }
  }
}
</script>
<style lang="less" scoped>
html {
  font-size: 16px;
}

.box {
  width: 100%;
  height: auto;
  background: url('/subject/newYear9911/wap/bg.png') no-repeat center;
  background-size: 100%;
  .tabNew {
    width: 100%;
    height: 89px;
    background: url('../../../../static/common/wap/tab.png') no-repeat;
    background-size: cover;
    box-sizing: border-box;
    padding: 0 3px;

    // position: relative;
    .tabTop {
      width: 100%;
      height: 51px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      div {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        ul {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0;

          .hongshi {
            width: 37.5px;
            margin: 0 10px;
          }

          p {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            font-size: 12px;
          }
        }

        .downLoadApp {
          width: 101.5px;
          margin-top: 10px;
          margin-right: 10px;
        }
      }
    }

    .tabBottom {
      font-size: 12px;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      box-sizing: border-box;
      padding-left: 10px;
      margin: 5px 0;
    }

    .closer {
      width: 12px;
      position: absolute;
      top: 3px;
      right: 3px;
    }
  }

  .navBarFixed {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .BannerBox {
    // position: relative;
    width: 100%;
    height: auto;
    .banner {
      width: 100%;
      display: block;
    }
  }

  .content {
    width: 100%;
    height: 556rem;
    box-sizing: border-box;
    padding: 0;
    .logins {
      width: 100%;
      height: auto;
      position: relative;
      top: -5.5rem;
      #login {
        width: 68.9rem;
        height: 70rem;
        margin: 0 auto;
        background: url('/subject/newYear9911/wap/zhuce.png') no-repeat center;
        background-size: 100%;
        .interactive {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          .line {
            width: 100%;
            height: 15rem;
            margin: 0 auto;
          }
          input:focus {
            outline: none;
          }
          input {
            width: 62.9rem;
            height: 8.8rem;
            background: #fff;
            border: none;
            border-radius: 1rem;
            font-size: 2.6rem;
            text-indent: 2.5rem;
            list-style: none;
            border: 1px solid #e31224;
          }

          .codeBox {
            height: 8.8rem;
            position: relative;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            margin: 3.5rem 0;
            span {
              width: 17.8rem;
              height: 6.4rem;
              line-height: 6.4rem;
              background-color: #fcdeae;
              font-size: 3.1rem;
              border-radius: 1rem;
              text-align: center;
              color: #cf0405;
              position: absolute;
              top: 1.5rem;
              right: 1.2rem;
            }
          }

          .loginBtn {
            width: 57rem;
            height: 12rem;
            margin-top:2rem;
          }
          .djs {
            width: 100%;
            text-align: center;
            color: #fff2d5;
            span {
              font-weight: 600;
            }
            .djs-box {
              margin-top: 1rem;
              font-size: 3.6rem;
              span {
                display: inline-block;
                width: 6.6rem;
                height: 6.8rem;
                line-height: 6.8rem;
                background-color: #a10b11;
                color: #fff2d5;
                margin: 0 0.5rem;
                border-radius: 1.3rem;
                border: 1px solid #fcdaa6;
              }
            }
          }
        }
      }
    }
    .part {
      width: 100%;
      height: auto;
      .part-con {
        width: 68.1rem;
        height: 121rem;
        margin: 0 auto;
        background: url('/subject/newYear9911/wap/1.png') no-repeat center;
        background-size: 100%;
        .line {
          width: 100%;
          height: 13.8rem;
        }
        .img1 {
          width: 33.9rem;
          height: 4.5rem;
          margin: 0 auto;
          background: url('/subject/newYear9911/wap/newuser.png') no-repeat center;
          background-size: 100%;
          margin-bottom: 2rem;
        }
        .part-1-span {
          width: 10rem;
          height: 3.8rem;
          margin: 0 auto;
          text-decoration: underline;
          color: #c0705e;
          font-size: 1.8rem;
          display: block;
          margin-bottom: 2rem;
        }
        .list {
          width: 100%;
          height: auto;
          .gift1 {
            width: 57rem;
            height: 34.5rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/1000.png') no-repeat center;
            background-size: 100%;
          }
          .gift2 {
            width: 100%;
            height: 32.4rem;
            display: flex;
            justify-content: space-between;
            margin-top: 1.5rem;
            .g100 {
              width: 27.1rem;
              height: 32.4rem;
              background: url('/subject/newYear9911/wap/100.png') no-repeat center;
              background-size: 100%;
              margin: 0 3.8rem;
            }
            .g500 {
              width: 27.1rem;
              height: 32.4rem;
              background: url('/subject/newYear9911/wap/500.png') no-repeat center;
              background-size: 100%;
              margin: 0 3.8rem;
            }
          }
          .gift-t {
            width: 60rem;
            height: 13.6rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/gift-t.png') no-repeat center;
            background-size: 100%;
            margin-bottom: 2rem;
          }
          .part-1-bth {
            width: 100%;
            height: 10.8rem;
            display: flex;
            justify-content: center;
            .zxkf {
              width: 28.4rem;
              height: 10.8rem;
              background: url('/subject/newYear9911/wap/serve.png') no-repeat center;
              background-size: 100%;
            }
            .lzj {
              width: 28.4rem;
              height: 10.8rem;
              background: url('/subject/newYear9911/wap/openacc.png') no-repeat center;
              background-size: 100%;
            }
          }
        }
        
      }
    }

    .part2 {
      width: 100%;
      height: auto;
      margin-top: 7.8rem;
      .part-2-bth {
        width: 68.1rem;
        height: 192.4rem;
        margin: 0 auto;
        background: url('/subject/newYear9911/wap/2.png') no-repeat center;
        background-size: 100%;
        .line152 {
          width: 100%;
          height: 15.2rem;
        }
        .p2con {
          width: 64.9rem;
          height: 161.9rem;
          margin: 0 auto;
          background: url('/subject/newYear9911/wap/p2con.png') no-repeat center;
          background-size: 100%;
          background-position-x: 0.8rem;
        }
        .anniu {
          width: 100%;
          height: 10.8rem;
          display: flex;
          justify-content: center;
          .zxkf {
            width: 28.4rem;
            height: 10.8rem;
            background: url('/subject/newYear9911/wap/serve.png') no-repeat center;
            background-size: 100%;
          }
          .lzj {
            width: 28.4rem;
            height: 10.8rem;
            background: url('/subject/newYear9911/wap/openacc.png') no-repeat center;
            background-size: 100%;
          }
        }
      }
    }
    .part3 {
      width: 100%;
      height: auto;
      margin-top: 7.8rem;
      .part-3-bth {
        width: 68.1rem;
        height: 138.1rem;
        margin: 0 auto;
        background: url('/subject/newYear9911/wap/3.png') no-repeat center;
        background-size: 100%;
        .line205 {
          width: 100%;
          height: 20.5rem;
        }
        .list {
          width: 100%;
          height: auto;
          margin-bottom: 4.8rem;
          .con1 {
            width: 65.7rem;
            height: 19.9rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/p3-1.png') no-repeat center;
            background-size: 98%;
            margin-bottom: 1.7rem;
          }
          .con2 {
            width: 65.7rem;
            height: 19.9rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/p3-2.png') no-repeat center;
            background-size: 98%;
            margin-bottom: 1.7rem;
          }
          .con3 {
            width: 65.7rem;
            height: 19.9rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/p3-3.png') no-repeat center;
            background-size: 98%;
            margin-bottom: 1.7rem;
          }
          .con4 {
            width: 65.7rem;
            height: 19.9rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/p3-4.png') no-repeat center;
            background-size: 98%;
            margin-bottom: 4.7rem;
          }
          .con5 {
            width: 48.4rem;
            height: 6.4rem;
            margin: 0 auto;
            background: url('/subject/newYear9911/wap/p3-5.png') no-repeat center;
            background-size: 100%;
            margin-bottom: 1.7rem;
          }
        }
        .anniu {
          width: 100%;
          height: 10.8rem;
          display: flex;
          justify-content: center;
          .zxkf {
            width: 28.4rem;
            height: 10.8rem;
            background: url('/subject/newYear9911/wap/serve.png') no-repeat center;
            background-size: 100%;
          }
          .lzj {
            width: 28.4rem;
            height: 10.8rem;
            background: url('/subject/newYear9911/wap/openacc.png') no-repeat center;
            background-size: 100%;
          }
        }
      }
    }
  }

  .dialog {
    position: relative;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95%;
    height: 400px;
    box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
    background-color: #fff;
    border-radius: 10px;
    overflow-y: scroll;
    z-index: 99999999;

    .closer {
      width: 20px;
      height: auto;
      position: absolute;
      top: 8px;
      right: 8px;
    }

    .dialogContent {
      box-sizing: border-box;
      padding: 25px 15px 15px;
      overflow: hidden;
      background: url('/subject/mayPage/rulesBackground.png') no-repeat;
      background-size: 100% 100%;

      h3 {
        color: #d88f4f;
        text-align: center;
        margin-top: 0px;
      }

      .imgLiBox {
        overflow-x: auto;

        img {
          width: 500px;
        }
      }

      li {
        font-size: 14px;
        color: #464646;
        line-height: 24px;

        span {
          font-weight: 600;
          color: #d88f4f;
        }

        img {
          width: 100%;
          height: auto;
          margin: 20px 0;
        }

        table {
          width: 100%;
          border: 1px solid #464646;
          border-radius: 10px;

          tr {
            th {
              text-align: center;
              font-weight: 500;
              line-height: 24px;
              border-bottom: 1px solid #464646;
              border-right: 1px solid #464646;
              padding: 5px;
            }

            th:last-child {
              border-right: 1px solid transparent;
            }
          }

          tr:nth-child(1) {
            th {
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  .dark {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .5;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 101;
  }

  .bottomBar {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 0;
    background-color: #fff0ed;
    position: fixed;
    bottom: 0;

    p {
      width: 85%;
      height: 39px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;

      img {
        width: 19px;
        margin-right: 5px;
      }

      span {
        font-size: 15px;
      }
    }

    p:nth-child(1) {
      border: 1px solid #d52226;
      border-radius: 20px;
      margin-bottom: 10px;

      span {
        color: #d52226;
      }
    }

    p:nth-child(2) {
      background: url('../../../../static/common/wap/botBtn.png') no-repeat;
      background-size: 100% 100%;

      span {
        color: #fff;
      }
    }
  }
}

@media screen and (min-width: 280px) and (max-width: 384px) {
  .box {
    .BannerBox {
      #login {
        bottom: 0;
      }
    }
  }
  .box .content {
    .part1 {
      .btu {
        top: -4rem;
      }
    }

    .part2 {
      .btu {
        top: -4rem;
      }
    }

    .part3 {
      
    }

    .part4 {
      .btu4 {
        .totop {
          top: -29.625rem;
        }
      }

      .down {
        margin-top: -13.5rem;

        .android,
        .ios {
          text-align: center;
          font-size: 14px;

          span {
            display: inline-block;
            position: relative;
            top: -6px;
          }
        }
      }
    }

    .part5 {
      margin-top: -3.5rem;
    }
  }

  .box {
    .openTabBar {
      height: 3340px !important;
    }
  }
}

@media screen and (min-width: 385px) and (max-width: 409px) {
  .box .content {
    .part4 {
      .btu4 {
        .totop {
          top: -32.0625rem;
        }
      }

      .down {
        margin-top: -14.5rem;

        .android,
        .ios {
          text-align: center;
          font-size: 14px;

          span {
            display: inline-block;
            position: relative;
            top: -6px;
          }
        }
      }
    }
  }

  .box {
    .openTabBar {
      height: 3230px !important;
    }

    .BannerBox {
      #login {
        bottom: 1em;
      }
    }
  }
}

@media screen and (min-width : 410px) and (max-width: 450px) {
  .box {
    .BannerBox {
      #login {
        bottom: 2rem;
      }
    }
  }

  .box .content {
    .part4 {
      .btu4 {
        .totop {
          top: -34.0625rem;
        }
      }

      .down {
        margin-top: -15.2rem;

        .android,
        .ios {
          text-align: center;
          font-size: 14px;

          span {
            display: inline-block;
            position: relative;
            top: -6px;
          }
        }
      }
    }
  }

  .box {
    .openTabBar {
      // height: 3945px !important;
    }
  }
}
</style>